<!-- /components/secure/breadcrumbs.vue -->
<template>
    <nav v-if="!smAndUp" class="mb-4 font-weight-medium text-body-1 d-flex align-center">
        <NuxtLink v-for="(crumb, index) in breadcrumbs" :key="index" :to="crumb.disabled ? undefined : crumb.to"
            class="text-decoration-none" :disabled="crumb.disabled">
            <span :class="{ 'text-primary': !crumb.disabled, 'text-medium-emphasis': crumb.disabled }"
                :style="crumb.disabled ? '' : 'cursor: pointer'">
                {{ crumb.label }}
            </span>
            <span v-if="index < breadcrumbs.length - 1" class="mx-2 text-high-emphasis">•</span>
        </NuxtLink>
    </nav>

    <div class="d-flex align-center mb-8">
        <div class="d-flex align-center ga-3">
            <img v-if="route.meta.image" :src="route.meta.image" alt="Page Icon" width="40" height="40" />
            <VIcon v-else :icon="pageIcon" size="40" color="primary" />
            <div>
                <div
                    :class="`${store.backgroundTheme === 'none' && theme.global.name.value === 'light' ? 'index-title-light' : 'index-title'} index-title font-weight-medium text-md-h4 text-h5 mb-1`">
                    {{ pageTitle }}
                </div>

                <p class="text-body-2 text-medium-emphasis">
                    {{ pageSubtitle }}
                </p>
            </div>
        </div>


        <VSpacer v-if="smAndUp" />

        <nav v-if="smAndUp" class="font-weight-medium text-body-1 d-flex align-center">
            <NuxtLink v-for="(crumb, index) in breadcrumbs" :key="index" :to="crumb.disabled ? undefined : crumb.to"
                class="text-decoration-none" :disabled="crumb.disabled">
                <span :style="crumb.disabled ? '' : 'cursor: pointer'"
                    :class="{ 'text-primary': !crumb.disabled, 'text-medium-emphasis': crumb.disabled }">
                    {{ crumb.label }}
                </span>
                <span v-if="index < breadcrumbs.length - 1" class="mx-2 text-high-emphasis">•</span>
            </NuxtLink>

        </nav>
    </div>

</template>

<script setup lang="ts">
import { useAppStore } from '@S/appStore.ts';
import { useUserDataStore } from '@S/userDataStore.ts';
import { useTheme, useDisplay } from 'vuetify';
import { useBreadcrumbs } from '@R/composables/useBreadcrumbs';
import { useRoute } from 'vue-router';

const route = useRoute();
const { smAndUp } = useDisplay();
const theme = useTheme();
const store = useAppStore();
const userData = useUserDataStore();

const currentTime = ref(new Date());
let timer: ReturnType<typeof setInterval> | null = null;

const greeting = computed(() => {
    const hour = currentTime.value.getHours();
    if (hour < 12) return 'Good Morning';
    if (hour < 18) return 'Good Afternoon';
    if (hour < 21) return 'Good Evening';
    return 'Goodnight';
});







const pageIcon = computed(() => {
    const metaIcon = route.meta.icon as string | undefined;

    if (metaIcon) return metaIcon;

    // Fallback
    return '$info';
});

const pageTitle = computed(() => {
    const baseGreeting = `${greeting.value} ${userData.user.firstName}`;

    // Dashboard → always greeting
    if (route.path.includes('/dashboard')) {
        return baseGreeting;
    }

    // Other routes: meta.title if exists; otherwise greeting
    return (route.meta.title as string | undefined) ?? baseGreeting;
});

const pageSubtitle = computed(() => {
    // If the route provides its own subtitle, use that
    const metaSubtitle = route.meta.subtitle as string | undefined;
    if (metaSubtitle) return metaSubtitle;

    // Otherwise: formatted date + time (using the live currentTime ref)
    const datePart = currentTime.value.toLocaleDateString(undefined, {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });

    const timePart = currentTime.value.toLocaleTimeString(undefined, {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
    });

    return `${datePart} ${timePart}`;
});



onMounted(() => {
    timer = setInterval(() => {
        currentTime.value = new Date();
    }, 1000);
});

onBeforeUnmount(() => {
    if (timer) clearInterval(timer);
});

const { breadcrumbs } = useBreadcrumbs();
</script>
